import PropTypes from "prop-types";
import React from "react";

import AddDestinationForm from "v2/components/responsive/AddDestinationForm";

const AddDestinationPage = (props, context) => {
  const {location: {query}, params: {date, routeId}, router} = context;
  return (
    <AddDestinationForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}`,
          query,
        });
      }} />
  );
};

AddDestinationPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default AddDestinationPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/AddDestinationPage.js
 **/